export const setAppSizeAction = async (width: number, height: number) => {
    if (!window.electronApi) {
        return;
    }

    window.electronApi.setSize(width, height);
};
